import { Toast } from "antd-mobile";
import {hideLoading, showLoading} from "@/components/loading";
import appService from "@/utils/appService";
import requests from "@/utils/requests_self";

class Service {

    // 查询权益领取详情
    static benefitGetOrderDetail = async (reqId, nftNo) => {
        if(nftNo && nftNo !== 'undefined' && nftNo !== 'null') {
            return await requests.get(`/customer/benefit/v1/orderDetail?reqId=${reqId}&nftNo=${nftNo}`);
        } else {
            return await requests.get(`/customer/benefit/v1/orderDetail?reqId=${reqId}`);
        }
    }

    // 领取权益
    static benefitGet = async (params) => {
        return await requests.post('/customer/benefit/v1/claim', JSON.stringify(params));
    }

    static queryAddressList = async (params={}, isRefesh=false) => {
        try {
            isRefesh && showLoading();
            const res = await appService("101294",params, false);
            isRefesh && hideLoading();
            return res
        } catch (error) {
            isRefesh && hideLoading();
            Toast.show(error);
        }
    }

    /**
     * @description 查询常用地址
     * @param {*}
     * @returns
     */
    static queryCommonAddress = async ()=> {
        const result = await this.queryAddressList()
        let list = []
        let defaltAddress;
        if(result) {
            list = result.data || []
        }
        //查找默认地址
        defaltAddress = list.find(item => item.isDefaltAddress == 1)
        if(!defaltAddress && list.length>0) {
            defaltAddress = list[0]
        }

        return defaltAddress

    }

}
export default Service;
